import { render } from "./DatePickerComponent.vue?vue&type=template&id=3383dc0a"
import script from "./DatePickerComponent.vue?vue&type=script&lang=js"
export * from "./DatePickerComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__